import { Component, OnInit, ViewChild, Input, Output, ElementRef, EventEmitter, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup, FormArray, ReactiveFormsModule, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { ValidationService } from '../../../app/validation.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
import { UploadService } from '../../../app/shared/upload.service';
import { Subscription } from 'rxjs-compat/Subscription';
import { HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType } from '@angular/common/http';
import  moment from 'moment-timezone';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FileUploadModule } from 'ng2-file-upload';
import { MatIconModule } from '@angular/material/icon';

interface ChildOption {
  name: string;
}

interface SubOption {
  name: string;
  childOptions: ChildOption[];
  showChildren?: boolean;
}

interface TabOption {
  name: string;
  subOptions: SubOption[];
}

interface ReportRole {
  id: number;
  role: string;
}
@Component({
  selector: 'app-admin-create-clients',
  templateUrl: './admin-create-clients.component.html',
  styleUrls: ['./admin-create-clients.component.scss'],
  standalone: true,
  imports:[MatIconModule,NgbNavModule,CommonModule,MatDialogModule,NgbModule,FormsModule,MatRadioModule,MatSlideToggleModule,ReactiveFormsModule, MatButtonModule,NgxSpinnerModule,NgxIntlTelInputModule, FileUploadModule]
})



export class AdminCreateClientsComponent implements OnInit,AfterViewInit {
  public middlewareBaseUrl= BaseUrlConstantsService.BASE_MIDDLEWARE_URL
  public registerUserUrl = BaseUrlConstantsService.REGISTER_USERS;
  public managerListingUrl = BaseUrlConstantsService.MANAGER_LIST;
  public inventoryInfoCount = BaseUrlConstantsService.INVENTORY_INFO_COUNT;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL;
  public imageUpdateInfoUrl = BaseUrlConstantsService.UPDATE_IMAGE_INFO;
  public editUserUrl = BaseUrlConstantsService.EDIT_USER_INFO;
  private deviceTypeListingUrl = BaseUrlConstantsService.DEVICE_TYPE_LIST;
  public userLicenceUrl = BaseUrlConstantsService.USERS_LICENCE_LIST;
  public updateLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public checkUserName = BaseUrlConstantsService.CHECK_USERNAME;
  public alertBaseUrl = BaseUrlConstantsService.BASE_ALERT_URL;
  public productListingUrl = BaseUrlConstantsService.PRODUCTLIST;
  public getClientProductsUrl = BaseUrlConstantsService.CLIENTS_PRODUCTS
  public getClientSubscriptionUrl = BaseUrlConstantsService.CLIENTS_SUBSCRIPTIONS;
  public reportSubscriptionUrl = BaseUrlConstantsService.REPORT_SUBSCRIPTION_ROLES;
  public reportSubscriptionCheckUrl = BaseUrlConstantsService.REPORT_SUBSCRIPTION_CHECK;
  public generateSubscriptionKeyURL = BaseUrlConstantsService.GENERATE_SUBSCRIPTION_KEY;
  public clientSubscriptionURL = BaseUrlConstantsService.CLIENTS_SUBSCRIPTIONS_URL;

  showIndustryInput: boolean;
  showIndustryDropDown: boolean = true;

  public options: FormGroup;
  public uForm: any;
  infoLicenceCount: any = {};
  public visible = true;
  public selectable = true;
  public removable = true;
  typeArray: any = [];
  public addOnBlur = true;
  public countryNames: any;
  public maxLength = 0;
  public allCitys: any;
  public pageRef: any;
  public selectedCountry: any;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showViewLicense: boolean;
  public states: any = [];
  public showSavebtn: boolean;
  public title = 'Upload a File';
  public managerList: any;
  public url: any;
  public userId: any;
  saveArrayVal: any = [];
  public licenceTypeArray = [];
  public id: any;
  licenceResult: any = [];
  public showCancelBtn: boolean;
  percentDone = 0;
  uploadSuccess: boolean;
  public _adminClientId: any;
  public updateDataReq: any = false;
  public _imgUrl: any = "./assets/img-new/default_user.png";
  public _companyLogo: any = "./assets/img-new/default_user.png";
  imagePath: any;
  public bredCrupVal = 'add-client';
  public breadcrumbsArray: any = [
    'Clients',
    'add-client'
  ];
  public defaultFlgONphone: string= "";
  public uploader: FileUploader;
  public companyUploader : FileUploader;
  public industryType: any = [];
  public form: FormGroup;
  public deviceArrayList: any = [];
  public error: string;
  public uploadResponse = { status: '', message: '', filePath: '' };
  public fileName = '';
  siteInchargeList: any = [];
  public _imageId = null;
  public timeZones: any = [];
  public company: string;
  public CompanyLicenseList: any = []
  public message: string = "";
  public msgColor: string = "";
  public isUserExist: boolean;
  public errorchecker:boolean = false;
  errormessage: string;
  errormessagepostel: string;
  country:any = ['CA','INDIA','USA']
  countryname
  countrycode: any='+1';
  Phonenumber: boolean=false;
  flagchecker: any;
  resFunction: (ev: any) => any;
  public companyfileName: string;
  public checkBoxList: any =[];
  public productBoxList: any =[];
  public master_products: any =[]; // active master products from DB shown as options unchecked (EDIT/CREATE)
  public software_types: any =[];
  public software_types_v2: any =[];
  public selectedIds: any =[];
  public client_softwares:any=[];
  public client_softwares_v2:any=[];
  public client_master_products: any =[]; // master products subs. by client shown as checked options (EDIT)
  public clientProducts: any =[];
  public clientProductString:any;
  public ordersFormArray: any=[];
  OEMString: any;
  public OEMArray: any = [];
  public tabsList = ['Monitoring','Diagnostics','Predictive','Diagnostics Summary' ,'Velocity Spectra','Acceleration Spectra','Ultrasonic Spectra','Magnetic Field Spectra','Bearing Analysis'];
  public innerTabs = []
  public subscriptionTypes=['Email','SMS','Whatsapp','Managed Monitoring' ,'QR Login']
  public subscriptionString=['1']
  public tabActive
  public alertSubscriptionNames: any = [];

  changes: { tabId: number, status: string }[] = [];
  activeInnerTab = 0;

  public reportSubscriptionRoles : ReportRole[] = [];

  public isGeneratingKey: boolean = false;
  public isKeyGenerated: boolean = false;
  public subscriptionKey: string = '';
  public copied: boolean = false;
  public subscriptionStatus: string = '';



  // Toggle submenu for a sub option
  // toggleSubmenu(sub: any) {
  //   sub.showChildren = !sub.showChildren;
  // }
  constructor(
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    public router: Router,
    private uploadService: UploadService,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private formBuilder: FormBuilder) {
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.IMAGE_UPLOAD, itemAlias: 'photo' });
    this.companyUploader =new FileUploader({url: BaseUrlConstantsService.IMAGE_UPLOAD +'/logo', itemAlias: 'photo'})
    activeRoute.queryParams.subscribe(params => {
      this.countryname=params['countryname']
      switch (this.countryname) {
        case 'Canada':
          this.countryname= "ca";
          break;
        case 'India':
          this.countryname = "in";
          break;
        case 'United States':
          this.countryname = "us";
          break;
      }
      this.pageRef = params[`pageRef`];
      console.log("-----------params --------",params[`adminClientId`] )
      this._adminClientId = params[`adminClientId`];
      if (this._adminClientId !== undefined) {
        this.breadcrumbsArray[1] = 'Edit Client';
      }
      if (this.pageRef === 'admin-client') {
        this.showUpdateBtn = true;
        this.showEditUsertxt = 'Edit Client';
        this.showViewLicense = true;
        this.showSavebtn = false;
      } else {
        this.showUpdateBtn = false;
        this.showSavebtn = true;
        this.showEditUsertxt = 'Create Client';
        this.showViewLicense = false;
        this.isKeyGenerated = true;
      }
    });

  }
  oncode(country){
    this.countryname = country
    if(country=='CA'){
      this.countrycode = '+' +1
       }
       if(country=="INDIA"){
         this.countrycode = "+" + 91
       }
       if(country=="USA"){
         this.countrycode = "+" + 1
       }

  }




  onSelected(number){
if(this.countryname=='Ca' || this.countryname=='Usa'){
  if(number.target.value.length>11){
    this.Phonenumber =true
    this.errormessagepostel = 'Invalid Phone Number'
  }else{
    this.Phonenumber = false
  }
}else{
  if(number.target.value.length>13){
    this.Phonenumber =true
    this.errormessagepostel = 'Invalid Phone Number'
  }else{
    this.Phonenumber = false
  }
}
}



  upload(files: any, type) {
    if(type == 'clientPicture'){
      if (files[0].name !== undefined && files[0].name === '') {
        this.fileName = '';
      } else {
        this.showCancelBtn = true;
        this.fileName = files[0].name;

        if (this.showEditUsertxt !== 'Create Client') {
         this.uploader.uploadAll();
          this.uploader.onProgressItem = (progress: any) => {
            this.percentDone = progress['progress'];
          };
        } else {
          var reader = new FileReader();
          this.imagePath = files;
          reader.readAsDataURL(files[0]);
          reader.onload = (_event) => {
            this._imgUrl = reader.result;
          }

        }
      }
    }else{
      if (files[0].name !== undefined && files[0].name === '') {
        this.companyfileName = '';
      } else {
        this.showCancelBtn = true;
        this.companyfileName = files[0].name;

        if (this.showEditUsertxt !== 'Create Client') {
          this.companyUploader.uploadAll();
          this.companyUploader.onProgressItem = (progress: any) => {
            this.percentDone = progress['progress'];
          };
        } else {
          var reader = new FileReader();
          this.imagePath = files;
          reader.readAsDataURL(files[0]);
          reader.onload = (_event) => {
            this._companyLogo = reader.result;
          }
        }
      }
    }
  }

  private subscription: Subscription = new Subscription();
  uploadAndProgress(files: any, signedRequest, imageurl, userId, cId) {
    const formData = new FormData();
    this.subscription.add(this.http.put(signedRequest, files[0], { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          this.showCancelBtn = false;
          this.fileName = '';
          this.uploadSuccess = true;
          this._imgUrl = imageurl;
        }
      }));
  }
  cancelClick() {
    this.subscription.unsubscribe();
    this.fileName = '';
    this.showCancelBtn = false;
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  public setTypesforTabsMenu() {
    let tempArray = [];
    this.productBoxList.forEach(product => {
      tempArray.push({
        title: product.name,
        subOptions: []
      });
    });
    this.innerTabs = tempArray;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }


    getTabsAndViews() {
      const endpoint = this.middlewareBaseUrl+`get-tabStatus/${this._adminClientId}`;
      this.service.getDataV2(endpoint).then((data: any) => {
        this.mapApiDataToInnerTabs(data.data.body.body);
      });
    }


    mapApiDataToInnerTabs(apiResponse: any[]) {
      const productTypeMapping = this.productBoxList.filter(item => item.checked);
      const innerTabs = productTypeMapping.map(product => {
        const productData = apiResponse.find(prod => prod.product_type_id == product.id);
        return {
          title: product.name,
          subOptions: productData && productData.tabs
            ? productData.tabs.map(tab => ({
                id: tab.id,
                name: tab.name,
                selected: tab.status === 'Active',
                disabled: tab.id == 1,
                showChildren: tab.status === 'Active' && tab.children && tab.children.length > 0,
                childOptions: tab.children
                  ? tab.children.map(child => ({
                      id: child.id,
                      name: child.name,
                      selected: child.status === 'Active',
                      // Added new properties for third level mapping:
                      showSubChildren: child.status === 'Active' && child.children && child.children.length > 0,
                      subChildOptions: child.children
                        ? child.children.map(subChild => ({
                            id: subChild.id,
                            name: subChild.name,
                            selected: subChild.status === 'Active'
                          }))
                        : []
                    }))
                  : []
              }))
            : []
        };
      });
      this.innerTabs = innerTabs;
      this.spinner.hide();
    }

    onParentCheckboxChange(subOption: any, newValue: boolean) {
      subOption.selected = newValue;
      subOption.showChildren = newValue && subOption.childOptions && subOption.childOptions.length > 0;
      // Record the change for the parent tab.
      this.recordChange(subOption.id, newValue ? 'Active' : 'Inactive');
    }

    onChildCheckboxChange(childOption: any, newValue: boolean) {
      childOption.selected = newValue;
      // If the child has sub-child options, propagate the new value.
      if (childOption.subChildOptions && childOption.subChildOptions.length > 0) {
        childOption.subChildOptions.forEach(subChild => {
          subChild.selected = newValue;
          this.recordChange(subChild.id, newValue ? 'Active' : 'Inactive');
        });
      }
      // Record the change for the child.
      this.recordChange(childOption.id, newValue ? 'Active' : 'Inactive');
    }
    onSubChildCheckboxChange(subChildOption: any, newValue: boolean) {
      subChildOption.selected = newValue;
      this.recordChange(subChildOption.id, newValue ? 'Active' : 'Inactive');
    }


    recordChange(tabId: number, status: string) {
      const existing = this.changes.find(change => change.tabId === tabId);
      if (existing) {
        existing.status = status;
      } else {
        this.changes.push({ tabId, status });
      }
    }

    saveChanges() {
      // const clientId = localStorage.getItem('admin_client_id');
      // Call your backend update function (example below)
      const endpoint = this.middlewareBaseUrl+"set-tabStatus"
      const body={
       client_id: this._adminClientId, changes:this.changes
      }
      this.service.postData(endpoint,body).then(response => {
        // Optionally, clear changes array after update
        this.changes = [];
        this.router.navigate(['/clients'])
        this.service.showSuccess('Tabs updated successfully')
      }).catch(error => {
        console.error('Update error', error);
      });
    }

 async ngOnInit() {
  await this.getClientSubscription();
    try {
      this.spinner.show();
    this.timeZones = moment.tz.names();
    this.form = this.formBuilder.group({
      avatar: ['']
    });
    this.uForm = this.formBuilder.group({
      // username: new FormControl('', [Validators.required]),
      full_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      email: new FormControl('', ValidationService.emailValidator),
      industry_type: new FormControl('', [Validators.required]),
      phone_number: new FormControl('',[Validators.required]),
      address_line1: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      address_line2: new FormControl(''),
      country_name_: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      state_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      city_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      postcode: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      timezone: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      account_manager: new FormControl(''),
      site_incharge: new FormControl(''),
      company_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      OEMCheckBox: this.formBuilder.array([]),
      ProductCheckBox: this.formBuilder.array([]),
      MasterProductCheckBox: this.formBuilder.array([],this.atLeastOneInMasterProductsCheckedValidator()),
      SubscriptionCheckBox: this.formBuilder.array([
        new FormControl({value:true,disabled:true},Validators.required),
        new FormControl({value:false,disabled:false},Validators.required),
        new FormControl({value:false,disabled:false},Validators.required),
        new FormControl({value:false,disabled:false},Validators.required),
        new FormControl({value:false,disabled:false},Validators.required),
      ]),
      softwareCheckboxes: this.formBuilder.group({
          monitoring: new FormControl(false),
          diagnostics: new FormControl(false),
          selected: new FormControl(false),
          kurtosis: new FormControl(false),
          cepstrum: new FormControl(false),
          waterfallChart: new FormControl(false),
          predictiveTab: new FormControl(false),
          powertrain: new FormControl(false),
      }),
      softwareCheckboxesV2:this.formBuilder.array([]),
      //for products other than Rotating asset below group would be changed entirely
      tabsGroup: this.formBuilder.group({
        rotatingAsset: this.formBuilder.group({
          monitoring: new FormControl(false),
          diagnostics: this.formBuilder.group({
            selected: new FormControl(false),
            diagnostics_summary: this.formBuilder.group({
              selected: new FormControl(false),
              periodic_sa:new FormControl(false)
            }),
            velocitySpectra: new FormControl(false),
            accelerationSpectra: new FormControl(false),
            ultrasonicSpectra: new FormControl(false),
            magneticFieldSpectra: new FormControl(false),
            bearingAnalysis: new FormControl(false)
          }),
          predictive: new FormControl(false),
        }),
      }),
      alert_subscription: this.formBuilder.array([]),
      reportSubscription: this.formBuilder.array([])
    });

    this.getAllSiteIncharge();
    this.getAllManager();
    this.service.load().then(data => {
      this.countryNames = JSON.parse(JSON.stringify(data)).countries;
    });
    this.service.industryType().then(data => {
      this.industryType = JSON.parse(JSON.stringify(data)).industry;
    });
    this.checkBoxList = await this.service
    .getOEMUser()
    .then((res) => {
      return res;
    });
    this.addCheckboxes();
    if(this.showEditUsertxt == 'Create Client')
      this.fetchAlertSubscriptionTypes();

    this.productBoxList = await this.service.getProductType(this.productListingUrl).then((res) => {

      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        return JSON.parse(JSON.stringify(res)).data.body.body;
      } else {
        this.service.showError('Something went wrong.');
      }
    }).finally(()=>{
    })
    // this.master_products=[{product_type:1,name:"EmSaver Mini",id:1},{product_type:2,name:"EmSaver Standard",id:2},{product_type:3,name:"EmSaverStandard with RTD",id:3}] // hard coded for now, will be replaced with API call later
    // this.master_products = await this.service.getDataV2('http://localhost:3004/get-master-products').then((res:any) => {
    this.master_products = await this.service.getDataV2(`${this.middlewareBaseUrl}get-master-products`).then((res:any) => {
      if(res.data.code==200){
      if( res.data.body.body.length > 0){
          return res.data.body.body.map((item: {name: string, id: number }) => ({
            product_type: item.id,
            name: item.name,
            id: item.id,
            checked: false // Initialize checked as false
          }))
        }
      }
    })
    if(this.showEditUsertxt == 'Create Client') {
      this.software_types=await this.service.getDataV2(`${this.middlewareBaseUrl}get-software-products`).then((res:any) => {
      // this.software_types=await this.service.getDataV2(`http://localhost:3004/get-software-products`).then((res:any) => {
        if(res.data.code==200){
          if( res.data.body.body.length > 0){
            return res.data.body.body.map((item: {name: string, id: number,key:string }) => ({
              name: item.name,
              key:item.key,
              id: item.id,
              checked: false // Initialize checked as false
            }))
          }
        }
      })

    // this.software_types_v2=await this.service.getDataV2(`http://localhost:3004/get-software-products`).then((res:any) => {
    this.software_types_v2=await this.service.getDataV2(`${this.middlewareBaseUrl}get-software-products`).then((res:any) => {
      if(res.data.code==200){
        if( res.data.body.body.length > 0){
          return res.data.body.tree
        }
      }
    })
    console.log(this.software_types_v2, "this.software_types_v2")
    const formArray = this.buildFormArrayFromTree(this.software_types_v2);
    this.uForm.setControl('softwareCheckboxesV2', formArray);
    console.log(this.SoftwareCheckboxesV2, "this.SoftwareCheckboxesV2")
    const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
      // const monitoringGroup = parentArray.at(0) as FormGroup;
      // monitoringGroup.get('checked')?.disable();
      // monitoringGroup.get('checked')?.setValue(true);
      // const monitoringChildren = monitoringGroup.get('children') as FormArray;
      // const monitoringTab = monitoringChildren.at(0) as FormGroup;
      // monitoringTab.get('checked')?.disable();
      // monitoringTab.get('checked')?.setValue(true);
      // this.selectedIds=[1,4]; // initialize with montioring ids
      // want to disable all checkoxes whose check is false
      // this.software_types_v2.forEach((item:any) => {
      //   if(item.id !== 1 && item.id !== 4){
      //     const group = parentArray.at(item.id - 1) as FormGroup;
      //     group.get('checked')?.disable();
      //     group.get('checked')?.setValue(false);
      //   }
      // });


      // const diagnosticsSummaryTab = diagnosticsChildren.at(1) as FormGroup;

      // diagnosticsSummaryTab.get('checked')?.disable();
      // diagnosticsSummaryTab.get('checked')?.setValue(true);
      // this.disableUncheckedNonMonitoring(parentArray);
  }

    if(this.showEditUsertxt !== 'Create Client'){
      this.clientProducts = await this.service.getClientProductByID(this.getClientProductsUrl+ "/" +  Math.floor(Math.random() * 90 + 10) + this._adminClientId + Math.floor(Math.random() * 9000 + 1000)).then((res) => {
        const parsedRes = JSON.parse(JSON.stringify(res));

        if (parsedRes.data.status === 'success') {
            return parsedRes.data.body.body.map((item: { product_type_id: number }) => item.product_type_id);
        } else {
            this.service.showError('Something went wrong.');
            return []; // Return an empty array or handle the error as needed
        }
      });

      this.client_master_products = await this.service.getDataV2(`${this.middlewareBaseUrl}get-master-products?client_id=${this._adminClientId}`)
      .then((res:any) => {
        if(res.data.code==200){
          return res.data.body.body
        }
        else return [];
      }).catch((err:any)=>{
        console.error('Error fetching client master products:', err);
        return [];
      })
    }

    this.setTypesforTabsMenu()
      this.loadReportSubscriptionRoles();
    this.addProductCheckboxes();
    this.addMasterProductCheckboxes();
    if (this._adminClientId !== undefined) {
      // this.getAdminClientUserData();
      this.getTabsAndViews()
    }

    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('user_id', this._adminClientId);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        if (this._adminClientId !== undefined) {
          this.service.getData( this.imageUploadUrl + "/" + this._adminClientId).then(response => {
            if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
              this._imgUrl =  JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
              this.fileName = '';
              this.service.showSuccess('Saved successfully');
            }
          });
        }
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.companyUploader.onBuildItemForm = (item, form) =>{
      form.append("token" , localStorage.getItem('token'));
      form.append('user_id', this._adminClientId);
    }
    this.companyUploader.onAfterAddingFile = (file) => {file.withCredentials = false; };
      this.companyUploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        if (this._adminClientId !== undefined) {
          this.service.getData( this.imageUploadUrl + "/logo/" + this._adminClientId).then(response => {
            if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
              this._companyLogo =  JSON.parse(JSON.stringify(response)).data.body[0].company_logo;
              this.companyfileName = '';
              this.service.showSuccess('Saved successfully');
            }
          });
        }
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.getDeviceTypeListing();
    this.getInfoInventory();
    this.getCompanyLicence();
    this.showProfileImage();
    this.getUserLicence();
    }finally{
      this.spinner.hide();
    }
  }

  ngAfterViewInit(){

  }

buildFormArrayFromTree(tree: any[]): FormArray {
  const arr = this.formBuilder.array([]);

  tree?.forEach(node => {
    const group:any = this.formBuilder.group({
      id: [node.id],
      name: [node.name],
      checked: [node.checked?node.checked:false],
      children: this.buildFormArrayFromTree(node.children || []),
    });

    arr.push(group);
  });

  return arr;
}

  async getDeviceTypeListing() {
    this.service.getData( this.deviceTypeListingUrl + "/" + localStorage.getItem('user_id')).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.deviceArrayList = JSON.parse(JSON.stringify(res)).data.body;
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }


  getInfoInventory() {
    this.service.getData( this.inventoryInfoCount).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.infoLicenceCount = JSON.parse(JSON.stringify(res)).data.body;
      }
    });
  }


  showProfileImage() {
    if (this._adminClientId !== undefined) {
      this.service.getData( this.imageUploadUrl + "/" + this._adminClientId).then(response => {
        console.log('showProfileImage: ', response)
        if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
          this._imgUrl = JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
        }
      });
    }
  }

  async getAdminClientUserData() {
    this.updateDataReq = true;
    const body = {
      id: this._adminClientId
    };
    this.changeService.loader(true);
    this.service.getData(this.editUserUrl + "/" +
      Math.floor(Math.random() * 90 + 10) + this._adminClientId + Math.floor(Math.random() * 9000 + 1000) ).then(async response => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(response)).data.status === 'success') {
        this.fetchUserSubscriptions(); // call this to get subscription types of CLIENT
        const resp = JSON.parse(JSON.stringify(response)).data.body[0];
        console.log('user resp: ', resp)
        if(resp.oem_tags!= null){
         this.OEMArray = resp.oem_tags.split(',');
        }
        if(resp?.company_logo?.length > 1) {
          this._companyLogo = resp.company_logo;
        }
        if (resp.profile_image != null) {
          this._imgUrl = resp.profile_image;
        }
        this._imageId = resp.image_id;
        this.onChange(resp.country);
        this.company = resp.company_name;
        // if(resp.country=='Canada' || resp.country=='United States'){
        //     resp.phone_no=resp.phone_no.slice(2);
        // }else if(resp.country=='India'){
        //     resp.phone_no = resp.phone_no.slice(3);
        // }
        resp.phone_no=
        // this.uForm.get('username').disable({ emitEvent: false });
        this.uForm = this.formBuilder.group({
          // username: new FormControl(resp.username, [Validators.required]),
          full_name: new FormControl(resp.full_name, [Validators.required, this.noWhitespaceValidator]),
          email: new FormControl(resp.email, ValidationService.emailValidator),
          phone_number: new FormControl(resp.phone_no,[Validators.required]),
          industry_type: new FormControl(resp.industry_type, [Validators.required]),
          address_line1: new FormControl(resp.address_1, [Validators.required, this.noWhitespaceValidator]),
          address_line2: new FormControl(resp.address_2),
          country_name_: new FormControl(resp.country, [Validators.required, this.noWhitespaceValidator]),
          timezone: new FormControl(resp.timezone, [Validators.required, this.noWhitespaceValidator]),
          state_name: new FormControl(resp.state, [Validators.required, this.noWhitespaceValidator]),
          city_name: new FormControl(resp.city, [Validators.required, this.noWhitespaceValidator]),
          postcode: new FormControl(resp.postal_code, [Validators.required, this.noWhitespaceValidator]),
          // number_of_license: new FormControl(''),
          site_incharge:new FormControl(parseInt(resp.incharge_id)),
          account_manager: new FormControl(parseInt(resp.manager_id)),
          company_name: new FormControl(resp.company_name, [Validators.required, this.noWhitespaceValidator]),
          OEMCheckBox: this.formBuilder.array([]),
          ProductCheckBox: this.formBuilder.array([]),
          MasterProductCheckBox: this.formBuilder.array([],this.atLeastOneInMasterProductsCheckedValidator()),
          SubscriptionCheckBox: this.formBuilder.array([
            new FormControl({value:true,disabled:true},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
          ]),
          TabsCheckBox: this.formBuilder.array([
            new FormControl({value:true,disabled:true},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
            new FormControl({value:false,disabled:false},Validators.required),
          ]),
          softwareCheckboxes: this.formBuilder.group({
          monitoring: new FormControl(false),
          diagnostics: new FormControl(false),
          selected: new FormControl(false),
          kurtosis: new FormControl(false),
          cepstrum: new FormControl(false),
          waterfallChart: new FormControl(false),
          predictiveTab: new FormControl(false),
          powertrain: new FormControl(false),
      }),
        softwareCheckboxesV2:this.formBuilder.array([]),
        alert_subscription: this.formBuilder.array([]),
        reportSubscription: this.formBuilder.array([new FormControl({value:true,disabled:true},Validators.required),
        new FormControl({value:false,disabled:false},Validators.required)])

        });
        this.fetchAlertSubscriptionTypes(this._adminClientId)
        this.addCheckboxes();
        this.addProductCheckboxes();
        this.addMasterProductCheckboxes();
        this.loadReportSubscriptionRoles();
        try {
          this.addSoftwareCheckboxes();
        } catch (error) {
          console.log("SOME ERROR IN this.addSoftwareCheckboxes()")
        }

      } else {
        this.service.showError('Something went wrong.');
      }
    });
    this.client_softwares = await this.service.getDataV2(`${this.middlewareBaseUrl}get-software-products?client_id=${this._adminClientId}`)
      .then((res:any) => {
        if(res.data.code==200){
          return res.data.body.body
        }
        else return [];
      }).catch((err:any)=>{
        console.error('Error fetching client master products:', err);
        return [];
      })
      let sft_res:any = await this.service.getDataV2(`${this.middlewareBaseUrl}get-software-products?client_id=${this._adminClientId}`)
      // let sft_res:any = await this.service.getDataV2(`http://localhost:3004/get-software-products?client_id=${this._adminClientId}`)
      .then((res:any) => {
        if(res.data.code==200){
          return {tree:res.data.body.tree,selected_ids:res.data.body.selected_ids}
        }
        else return {tree:[],selcted_ids:[]};
      }).catch((err:any)=>{
        console.error('Error fetching client master products:', err);
        return [];
      })
      this.client_softwares_v2=sft_res.tree;
      this.selectedIds=sft_res.selected_ids;
      const formArray = this.buildFormArrayFromTree(this.client_softwares_v2);
      this.uForm.setControl('softwareCheckboxesV2', formArray);
      const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
      // if(this.isKeyGenerated){
        //  const monitoringGroup = parentArray.at(1) as FormGroup;
        // monitoringGroup.get('checked')?.disable();
        // monitoringGroup.get('checked')?.setValue(true);

        // const monitoringChildren = monitoringGroup.get('children') as FormArray;
        // const monitoringTab = monitoringChildren.at(0) as FormGroup;

        // monitoringTab.get('checked')?.enable();
        // monitoringTab.get('checked')?.setValue(true);
        //   const monitoringGroup2 = parentArray.at(2) as FormGroup;
        // monitoringGroup2.get('checked')?.enable();
        // monitoringGroup2.get('checked')?.setValue(true);

        // const monitoringChildren2 = monitoringGroup2.get('children') as FormArray;
        // const monitoringTab2 = monitoringChildren2.at(0) as FormGroup;
        // const monitoringTab3 = monitoringChildren2.at(1) as FormGroup;
        // const monitoringTab4 = monitoringChildren2.at(2) as FormGroup;
        // const monitoringTab5 = monitoringChildren2.at(3) as FormGroup;
        // const monitoringTab6 = monitoringChildren2.at(4) as FormGroup;

        // monitoringTab2.get('checked')?.enable();
        // monitoringTab2.get('checked')?.setValue(true);
        // monitoringTab3.get('checked')?.enable();
        // monitoringTab3.get('checked')?.setValue(true);
        // monitoringTab4.get('checked')?.enable();
        // monitoringTab4.get('checked')?.setValue(true);
        // monitoringTab5.get('checked')?.enable();
        // monitoringTab5.get('checked')?.setValue(true);
        // monitoringTab6.get('checked')?.enable();
        // monitoringTab6.get('checked')?.setValue(true);
      // }


    }
  onParentSoftwareCheckboxChange(event,parent){
    const checkbox = event.target as HTMLInputElement;
    const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
    let parentGroup = parentArray.at(parent.id-1) as FormGroup;
    let parentChildren = parentGroup.get('children') as FormArray;
    for(let i=0;i<parentChildren.length;i++){
      const child = parentChildren.at(i) as FormGroup;
      child.get('checked')?.setValue(checkbox.checked?true:false);
      const index = this.selectedIds.indexOf(child.value.id);
      if (checkbox.checked) {
        if (index === -1) {
          // Add ID if not already in the list
          this.selectedIds.push(child.value.id);
        }
      } else {
        if (index !== -1) {
              // Remove ID if it exists
              this.selectedIds.splice(index, 1);
            }
          }
        }
    // this handles only parent checkbox ie for Advanced Diagnostics Monitoring while above code handle the children
    this.onSoftwareCheckboxV2(parent);

    if(parent.id==3 && checkbox.checked){
      parentGroup = parentArray.at(1) as FormGroup;
      parentChildren = parentGroup.get('children') as FormArray;
      for(let i=0;i<parentChildren.length;i++){
      const child = parentChildren.at(i) as FormGroup;
      child.get('checked')?.setValue(checkbox.checked?true:false);
      const index = this.selectedIds.indexOf(child.value.id);
      if (checkbox.checked) {
        if (index === -1) {
          // Add ID if not already in the list
          this.selectedIds.push(child.value.id);
        }
      } else {
        if (index !== -1) {
              // Remove ID if it exists
              this.selectedIds.splice(index, 1);
            }
      }
     }
      const Group = parentArray.at(1) as FormGroup;
      Group.get('checked')?.setValue(true);

      const Children = Group.get('children') as FormArray;
      const Tab = Children.at(0) as FormGroup;

      Tab.get('checked')?.setValue(true);
    }
    // console.log(`PARENTID:${parent.id}, CHECKED:${checkbox.checked}`)
    if(parent.id==3 && !checkbox.checked){
      // const Group = parentArray.at(1) as FormGroup;
      // Group.get('checked')?.setValue(false);
      // const Children = Group.get('children') as FormArray;
      // const Tab = Children.at(0) as FormGroup;
      // Tab.get('checked')?.setValue(false);
    }

    // On selecting/unselecting  Diagnostics parent checkbox select/unselct all child of diagnostics 
    if(parent.id==2 && checkbox.checked){
      // parentGroup = parentArray.at(2) as FormGroup;
      // parentChildren = parentGroup.get('children') as FormArray;
    //   for(let i=0;i<parentChildren.length;i++){
    //   const child = parentChildren.at(i) as FormGroup;
    //   child.get('checked')?.setValue(checkbox.checked?true:false);
    //   const index = this.selectedIds.indexOf(child.value.id);
    //   if (checkbox.checked) {
    //     if (index === -1) {
    //       // Add ID if not already in the list
    //       this.selectedIds.push(child.value.id);
    //     }
    //   } else {
    //     if (index !== -1) {
    //           // Remove ID if it exists
    //           this.selectedIds.splice(index, 1);
    //         }
    //   }
    //  }
      // const Group = parentArray.at(2) as FormGroup;
      // Group.get('checked')?.setValue(true);

      // const Children = Group.get('children') as FormArray;
      // const Tab = Children.at(0) as FormGroup;

      // Tab.get('checked')?.setValue(true);
    }

    // if user unselects diagnostics Parent checkbox(false) then unselect all advanced checkboxes
    if(parent.id==2 && checkbox.checked==false){
      parentGroup = parentArray.at(2) as FormGroup;
      parentChildren = parentGroup.get('children') as FormArray;
      for(let i=0;i<parentChildren.length;i++){
        if(i==0 || i==3) continue; // skip predictive and powertrain checkbox
        const child = parentChildren.at(i) as FormGroup;
        child.get('checked')?.setValue(false);
        const index = this.selectedIds.indexOf(child.value.id);
        this.selectedIds.splice(index, 1);
      }
      // const Group = parentArray.at(2) as FormGroup;
      // Group.get('checked')?.setValue(false);

      // const Children = Group.get('children') as FormArray;
      // const Tab = Children.at(0) as FormGroup;

      // Tab.get('checked')?.setValue(false);
    }

    console.log(this.selectedIds)

  }


  async getAllManager() {
    this.service.getData( this.managerListingUrl + 'ACCOUNT_MANAGER').then(res => {
      if (JSON.parse(JSON.stringify(res)).data.body.length === 0) {} else {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.managerList = JSON.parse(JSON.stringify(res)).data.body;
        }
      }
    });
  }


  async getAllSiteIncharge() {
    this.service.getData( this.managerListingUrl + 'SITE_INCHARGE').then(res => {
      if (JSON.parse(JSON.stringify(res)).data.body.length === 0) { } else {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.siteInchargeList = JSON.parse(JSON.stringify(res)).data.body;
        }
      }
    });
  }
  get OEMCheckBox(){
    return this.uForm.get("OEMCheckBox") as FormArray;
  }
  get ProductCheckBox(){
    return this.uForm.get("ProductCheckBox") as FormArray;
  }
  get MasterProductCheckBox(){
    return this.uForm.get("MasterProductCheckBox") as FormArray;
  }
  get SubscriptionCheckBox(){
    return (this.uForm.get("SubscriptionCheckBox") as FormArray).controls;
  }
  get SoftwareCheckboxesV2(){
    return (this.uForm.get("softwareCheckboxesV2") as FormArray).controls;
  }
  get alertSubscriptionCheckboxes(){
    return (this.uForm.get("alert_subscription") as FormArray).controls;
  }

  get reportSubscriptionCheckboxes(){
    return (this.uForm.get("reportSubscription") as FormArray).controls;
  }
  addCheckboxes() {
    let condition= false;
    if (this._adminClientId !== undefined) {
      this.checkBoxList.forEach((key,index) =>{
        for(let oem of this.OEMArray){
          if(key.label == oem){
            condition=true;
            this.OEMCheckBox.push(new FormControl(true));
            break;
          }else{
            this.OEMCheckBox.push(new FormControl(false));
            break;
          }
        }

      });
    }else{
      this.checkBoxList.forEach(() =>
      this.OEMCheckBox.push(new FormControl(false))
      );
    }
  }

  onCheckboxChange(event: Event, id: number): void {
    const checkbox = event.target as HTMLInputElement;
    const selectedIds = this.getSelectedIds();
    if (checkbox.checked) {
      if (!this.clientProducts.includes(id)) {
        this.clientProducts.push(id);
      }
    } else {
      const index = this.clientProducts.indexOf(id);
      if (index > -1) {
        this.clientProducts.splice(index, 1);
      }
    }
  }
  onMasterProductCheckboxChange(event: Event, id: number): void {
    const checkbox = event.target as HTMLInputElement;
    // const selectedIds = this.getSelectedIds();
    if (checkbox.checked) {
      if (!this.clientProducts.includes(id)) {
        this.clientProducts.push(id);
      }
    } else {
      const index = this.clientProducts.indexOf(id);
      if (index > -1) {
        this.clientProducts.splice(index, 1);
      }
    }
  }

  getSelectedIds(): number[] {
    const formArray = this.form.get('ProductCheckBox') as FormArray;

    // Log formArray to check if it's correctly initialized

    if (!formArray) {
      return [];
    }

    return this.productBoxList
      .map((item, i) => ({
        id: item.id,
        checked: formArray.at(i)?.value || false
      }))
      .filter(item => item.checked)
      .map(item => item.id);
  }



  addProductCheckboxes() {
    if (this._adminClientId !== undefined) {
      this.productBoxList.forEach((product,index) => {

        if (this.clientProducts.includes(product.id)) {
          product.checked = true;
          //this.ProductCheckBox.push(new FormControl(true));
          this.ProductCheckBox.push(new FormControl(true));

        }else{
          product.checked = false;
          this.ProductCheckBox.push(new FormControl(false));
        }

      });

    }else{
      this.productBoxList.forEach(product => {
        product.checked = false;
        this.ProductCheckBox.push(new FormControl(false));
      });
    }
    this.ProductCheckBox.at(0).setValue(true);
    this.ProductCheckBox.at(0).disable();
    const firstProduct = this.productBoxList[0];
    const event = { target: { checked: true } } as any;

    this.onCheckboxChange(event, firstProduct.id);

  }
  addMasterProductCheckboxes() {
    if (this._adminClientId !== undefined) {
      this.master_products.forEach((product,index) => {
        if (this.client_master_products.some(p => p.id == product.product_type)) {
          product.checked = true;
          //this.ProductCheckBox.push(new FormControl(true));
          this.MasterProductCheckBox.push(new FormControl(true));

        }else{
          product.checked = false;
          this.MasterProductCheckBox.push(new FormControl(false));
        }
      });
    }
    // handle on create client
    else{
      this.master_products.forEach(product => {
        product.checked = false;
        this.MasterProductCheckBox.push(new FormControl(false));
      });
    }

  }
addSoftwareCheckboxes() {
  if (this._adminClientId !== undefined) {
    this.software_types.forEach((sft) => {
      const isEnabled = this.client_softwares.some(s => s.key === sft.key);
      sft.checked = isEnabled;

      const ctrl = this.uForm.get(['softwareCheckboxes', sft.key]);
      if (ctrl) {
        ctrl.setValue(isEnabled);
      }
    });
  }
  //Disable monitoring checkbox
  const monitoringCtrl = this.uForm.get(['softwareCheckboxes', 'monitoring']);
  if (monitoringCtrl) {
    monitoringCtrl.disable();
    monitoringCtrl.setValue(true);
  }
}


  async saveUser() {
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    } else if (this._imageId != null) {
      _imgId = this._imageId;
    }
    if (this.showEditUsertxt === 'Create Client') {
      const selectedOrderIds = this.uForm.value.OEMCheckBox
      .map((checked: boolean, i: number) =>
        checked ? this.checkBoxList[i].label : null
      )
      .filter((v: any) => v !== null);

      this.OEMString = selectedOrderIds.toString();
      this.clientProductString = this.clientProducts.toString();
      if (this.uForm.dirty && this.uForm.valid) {
        // if(!this.isUserExist){
        //  return this.service.showError('Please select different username.');
        // }
        let reqObj = {
          client_id: localStorage.getItem("user_id"),
          manager_id: this.uForm.value.account_manager,
          incharge_id: this.uForm.value.site_incharge,
          full_name: this.uForm.value.full_name,
          phone_no: this.uForm.value.phone_number.e164Number,
          industry_type: this.uForm.value.industry_type,
          address_1: this.uForm.value.address_line1,
          address_2: this.uForm.value.address_line2,
          country: this.uForm.value.country_name_,
          timezone: this.uForm.value.timezone,
          state: this.uForm.value.state_name,
          city: this.uForm.value.city_name,
          postal_code: this.uForm.value.postcode,
          email: this.uForm.value.email,
          company_name: this.uForm.value.company_name,
          role: 'CLIENT',
          oem_tags:this.OEMString,
          client_products:this.clientProductString,
          client_global_services_relation:this.subscriptionString.filter(id=>id!='0').join(',')
        };
        if (_imgId != null) {
          reqObj['image_id'] = _imgId;
        }
        // if(reqObj.country=='Canada' || reqObj.country=='United States'){
        //   reqObj.phone_no= '+1' + reqObj.phone_no;
        // }else if(reqObj.country=='India'){
        //   reqObj.phone_no= '+91' + reqObj.phone_no;
        // }
        const body = reqObj;
        const {MasterProductCheckBox,softwareCheckboxes,reportSubscription}= this.uForm.getRawValue();
        this.master_products.forEach((product, index) => {
          product.checked = MasterProductCheckBox[index];
        });
        this.software_types.forEach((software, index) => {
          software.checked = softwareCheckboxes[software.key];
        });
        body['master_products']= this.master_products.filter(product => product.checked).map(product => product.id);
        let temparr=[]
        this.uForm.getRawValue().softwareCheckboxesV2.map(parent=>{
          if(parent.checked) temparr.push(parent.id)
            if(parent.children.length)
              parent.children.map(child=>{
            if(child.checked)
              temparr.push(child.id)
          })
        })
        body['report_subscriptions']=reportSubscription.map((item:any,i:number)=>{
          if(item) {return 1}
          else return 0;
        })
        console.log(this.uForm.getRawValue());
        body['software_types']= temparr
        this.changes=this.getChangesFromForm(this.uForm)
        this.changeService.loader(true);
        const selected_alert_subs=this.uForm.getRawValue().alert_subscription.map((item:any,i:number)=>{
          if(item) {return i+1}
          else return 0;
        }).filter((item:any)=>item!=0)
        body['alert_subscriptions']=selected_alert_subs;
        body['subscription_key'] = this.subscriptionKey;
        this.service.postData( this.registerUserUrl, body).then(res => {
        // this.service.postData( 'http://localhost:3000/users', body).then(res => {
          this.changeService.loader(false);
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === "Email already exist.") {
            this.service.showError(JSON.parse(JSON.stringify(res)).data.status);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            this._adminClientId = JSON.parse(JSON.stringify(res)).data.user_id;
            // this.saveChanges();
            this.addSettingsToClient(this._adminClientId);
            if (this.fileName !== '') {
              this.fileName;
              this.uploader.uploadAll();
              this.uploader.onProgressItem = (progress: any) => {
                this.percentDone = progress['progress'];
                if (this.percentDone === 100) {
                  this.service.showSuccess('User registered successfully');
                  this.router.navigate(['/clients']);
                }
              };
            }
            else {
              this.service.showSuccess('User registered successfully');
              this.router.navigate(['/clients']);
            }
            if(this.companyfileName!==''){
              this.companyUploader.uploadAll();
              this.companyUploader.onProgressItem =(progress: any) => {
                this.percentDone = progress['progress'];
                if (this.percentDone === 100) {
                  this.service.showSuccess('User registered successfully');
                  this.router.navigate(['/clients']);
                }
              };
            }
            else {
              this.service.showSuccess('User registered successfully');
              this.router.navigate(['/clients']);
            }
          } else {
            this.service.showError('Something went wrong.');
          }
        });
      }
    }
    else {
      const EditselectedOrderIds = this.uForm.value.OEMCheckBox
      .map((checked: boolean, i: number) =>
        checked ? this.checkBoxList[i].label : null
      )
      .filter((v: any) => v !== null);

      this.OEMString = EditselectedOrderIds.toString();
      this.clientProductString = this.clientProducts.toString();

      const body = {
        full_name: this.uForm.value.full_name,
        manager_id: this.uForm.value.account_manager,
        phone_no: this.uForm.value.phone_number.e164Number,
        incharge_id: this.uForm.value.site_incharge,
        address_1: this.uForm.value.address_line1,
        address_2: this.uForm.value.address_line2,
        industry_type: this.uForm.value.industry_type,
        country: this.uForm.value.country_name_,
        state: this.uForm.value.state_name,
        timezone: this.uForm.value.timezone,
        city: this.uForm.value.city_name,
        postal_code: this.uForm.value.postcode,
        email: this.uForm.value.email,
        company_name: this.uForm.value.company_name,
        image_id: _imgId,
        role: 'CLIENT',
        oem_tags:this.OEMString,
        client_products:this.clientProductString,
        client_global_services_relation:this.subscriptionString.filter(id=>id!='0').join(','),
        edited_by:'ADMIN'
      };
      // if(body.country=='Canada' || body.country=='United States'){
      //   body.phone_no= '+1' + body.phone_no;
      // }else if(body.country=='India'){
      //   body.phone_no= '+91' + body.phone_no;
      // }
      const {MasterProductCheckBox,softwareCheckboxes,reportSubscription}= this.uForm.getRawValue();
      console.log(reportSubscription);
      body['report_subscriptions']=reportSubscription.map((item:any,i:number)=>{
        if(item) {return 1}
        else return 0;
      })
        this.master_products.forEach((product, index) => {
          product.checked = MasterProductCheckBox[index];
        });
        this.software_types.forEach((software, index) => {
          software.checked = softwareCheckboxes[software.key];
        });
        body['master_products']= this.master_products.filter(product => product.checked).map(product => product.id);
        let temparr=[]
        this.uForm.getRawValue().softwareCheckboxesV2.map(parent=>{
          if(parent.checked) temparr.push(parent.id)
            if(parent.children.length)
              parent.children.map(child=>{
            if(child.checked)
              temparr.push(child.id)
          })
        })
        body['software_types']= temparr
        const selected_alert_subs=this.uForm.getRawValue().alert_subscription.map((item:any,i:number)=>{
          if(item) {return i+1}
          else return 0;
        }).filter((item:any)=>item!=0)
        body['alert_subscriptions']=selected_alert_subs;
      this.changeService.loader(true);
      this.service.putData(this.editUserUrl + "/" +  Math.floor(Math.random() * 90 + 10) + this._adminClientId + Math.floor(Math.random() * 9000 + 1000) , body).then(res => {
      // this.service.putData("http://localhost:3000/users" + "/" +  Math.floor(Math.random() * 90 + 10) + this._adminClientId + Math.floor(Math.random() * 9000 + 1000) , body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Client updated successfully');
          this.router.navigate(['/clients']);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success' && localStorage.getItem('role') === 'OEM') {
          this.service.showSuccess('Client updated successfully');
          this.router.navigate(['/OEM-Client']);
        }else {
          // this.service.showError('Something went wrong.');
        }
      });
    }

  }

  getChangesFromForm(form: FormGroup): any[] {
  const changes: { tabId: number, status: string }[] = [];

  const tabIdMapping = {
    monitoring: 1,
    diagnostics_selected: 2,
    predictive: 3,
    diagnostics_summary_selected: 4,
    velocitySpectra: 5,
    accelerationSpectra: 6,
    ultrasonicSpectra: 7,
    magneticFieldSpectra: 8,
    bearingAnalysis: 9,
    diagnostics_summary_periodic_sa: 10,
  };

  const rotatingAsset = this.uForm.get('tabsGroup.rotatingAsset') as FormGroup;

  const monitoring = rotatingAsset.get('monitoring')?.value;
  changes.push({ tabId: tabIdMapping.monitoring, status: monitoring ? 'Active' : 'Inactive' });

  const diagnostics = rotatingAsset.get('diagnostics') as FormGroup;

  const selected = diagnostics.get('selected')?.value;
  changes.push({ tabId: tabIdMapping.diagnostics_selected, status: selected ? 'Active' : 'Inactive' });

  const diagnosticsSummary = diagnostics.get('diagnostics_summary') as FormGroup;

  const summarySelected = diagnosticsSummary.get('selected')?.value;
  changes.push({ tabId: tabIdMapping.diagnostics_summary_selected, status: summarySelected ? 'Active' : 'Inactive' });

  const periodicSa = diagnosticsSummary.get('periodic_sa')?.value;
  changes.push({ tabId: tabIdMapping.diagnostics_summary_periodic_sa, status: periodicSa ? 'Active' : 'Inactive' });

  ['velocitySpectra', 'accelerationSpectra', 'ultrasonicSpectra', 'magneticFieldSpectra', 'bearingAnalysis'].forEach(key => {
    const tabId = tabIdMapping[key];
    const value = diagnostics.get(key)?.value;
    if (tabId) {
      changes.push({ tabId, status: value ? 'Active' : 'Inactive' });
    }
  });

  const predictive = rotatingAsset.get('predictive')?.value;
  changes.push({ tabId: tabIdMapping.predictive, status: predictive ? 'Active' : 'Inactive' });

  return changes;
}


  openListPage() {
    if(localStorage.getItem('role') === 'OEM'){
      this.router.navigate(['/OEM-Client']);
    }else{
      this.router.navigate(['/clients']);
    }
  }

  addSettingsToClient(clientID) {
    let payload = {
      "client_id": clientID
    }
    this.service.postData( `${this.alertBaseUrl}alert/settings/configurations/default`, payload).then(res => {
      let result = JSON.parse(JSON.stringify(res));
    });
  };

  selectedIndustryType(valueS: string) {
    // if (valueS === 'Other') {
    //   this.showIndustryInput = true;
    //   this.showIndustryDropDown = false;
    // } else {
    //   this.showIndustryInput = false;
    //   this.showIndustryDropDown = true;
    // }
  }



  onChangeCity(event){
    var matches = event.match(/\d+/g);
 if(!matches){
  this.errormessage = "";
 }else{
  this.errorchecker = true
  this.errormessage = "invalid! City";
 }
}

onChangePostal(event){
  // var matches = event.match(/[a-zA-Z]/g);
  // console.log(matches)
  // if(!matches){
  //   this.errormessagepostel = "";
  //  }else{
  //   this.errorchecker = true
  //   this.errormessagepostel = "invalid! Postel code";
  //  }
}

  onChange(deviceValue) {
    let pullIndex;
    this.selectedCountry = deviceValue;
    if (deviceValue === 'Canada') {
      pullIndex = 1;
      this.maxLength = 6;
    } else if (deviceValue === 'United States') {
      pullIndex = 0;
      this.maxLength = 5;
    } else {
      pullIndex = 2;
      this.maxLength = 6;
    }
    this.service.load().then(data => {
      this.states = JSON.parse(JSON.stringify(data)).countries[pullIndex].states;
    });
  }

  selectedState(state) {

  }

  onCountryChange(num){
      Object.keys(this.uForm.controls).forEach(key => {
        const control = this.uForm.get(key);
        if (control && control.invalid) {
          console.warn(`Control "${key}" is invalid:`, control.errors);
        }
      });

  }
  addClient() {
    this.router.navigate(['/add-client']);
  }

  showLicense(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense',
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  saveCollection() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['/clients'], navigationExtras);
  }

  addDeviceType() {
    this.viewDeviceTypeDialogBox();
  }

//empty function
  onKeyUp(event: any) {

  };


  checkValue(valCh, i, qu, lef_qu, deviceType, devicetypeid) {
    if (valCh.checked) {
      let numberOfLicence: any = parseFloat((<HTMLInputElement>document.getElementById('license_number_' + i)).value);
      if (isNaN(numberOfLicence)) {
      } else {
        const body = {
          user_id: localStorage.getItem('user_id'),
          company_name: this.company,
          client_id: this._adminClientId,
          number_of_licence: numberOfLicence,
          quantity: qu,
          device_type_id: devicetypeid,
          device_type: deviceType,
          left_quantity: parseInt(lef_qu) - parseInt(numberOfLicence)
        };
        this.service.putData( this.updateLicenceUrl + '/updateby/' + valCh.id, body).then(res => {
          const result = JSON.parse(JSON.stringify(res))
          if (result.data.status === 'success') {
            this.service.showSuccess('Saved successfully.');
            this.getUserLicence();
          } else {
            this.service.showError('Something went wrong.');
          }
        })
      }
    }
  }

  getCompanyLicence() {
    this.service.getDataWithQuery( this.updateLicenceUrl).then(res => {
      const result = JSON.parse(JSON.stringify(res)).data.body;
      if (result.length !== 0) {
        this.CompanyLicenseList = result;
      }
    })
  }


  getUserLicence() {
    this.service.getData( this.updateLicenceUrl + "/client/" + this._adminClientId).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).length !== 0) {
        this.licenceTypeArray = JSON.parse(JSON.stringify(res));
      }
    })
  }

  viewDeviceTypeDialogBox() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '300px',
      maxWidth: '100%',
      data: {
        type: 'deviceTypeDailogBox',
        deviceDataArray: this.deviceArrayList

      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        for (let g = 0; g < result.length; g++) {
          let testva = this.CompanyLicenseList.filter(x => parseInt(x.device_type_id) === parseInt(result[g]));
          if (testva.length !== 0) {
            testva[0].number_of_licence = "";
            testva[0].left_quantity = parseInt(testva[0].quantity) - parseInt(testva[0].used);
            this.licenceTypeArray.push(testva[0]);
          }
        }
      }
    });
  };

  removeUserImage(val) {
    if(val == 'clientPicture'){
      this.service.getData( this.imageUploadUrl + "/remove/" + this._adminClientId).then(response => {
        this._imgUrl = "./assets/img-new/default_user.png";
        this.service.showSuccess('Removed successfully.');
      });
    }else{
        this.service.getData(this.imageUploadUrl + "/logo" + "/remove/" + this._adminClientId).then(response =>{
          this._companyLogo= "./assets/img-new/default_user.png";
          this.service.showSuccess("Removed successfully.");
        })
    }
  }


  public async userNameChange(value: string): Promise<string> {
    if (value.length < 1) {
      this.message = "";
      return this.message;
    } else {
      try {
        const response = await this.service.getData(this.checkUserName + value);
        const res = JSON.parse(JSON.stringify(response));
        this.message = res.data.body.message;
        this.isUserExist = res.data.body.valid;
        this.msgColor = res.data.body.valid ? "green" : "red";
        return this.message;
      } catch (error) {
        this.service.showError('Something went wrong.');
        return "";
      }
    }
  }


  onSubscriptionCheckboxChange(event: Event, i: number): void {
    const checkbox = (event.target as HTMLInputElement).checked;
    if(checkbox){
      this.subscriptionString[i]=`${i+1}`;
    }else{
      this.subscriptionString[i]='0';
    }
  }

  fetchUserSubscriptions(){
    this.service.getData(this.getClientSubscriptionUrl+'/'+ Math.floor(Math.random() * 90 + 10) +this._adminClientId +Math.floor(Math.random() * 9000 + 1000)).then(response=>{
      let data=JSON.parse(JSON.stringify(response))
      const {code,status,body}=data.data;
      if(code !== 200 || !body.body.length){
      this.service.showError("Error getting subscription of user")
      }
      const {is_email_delivery_enabled,is_sms_delivery_enabled,is_whatsapp_delivery_enabled,is_managed_monitoring_enabled,is_qr_login_enabled}=body.body[0]
      this.subscriptionString=[is_email_delivery_enabled,is_sms_delivery_enabled==1?'2':'0',is_whatsapp_delivery_enabled=='1'?'3':'0',is_managed_monitoring_enabled=='1'?'4':'0',is_qr_login_enabled=='1'?'5':'0']
      const subscriptionArray = this.uForm.get('SubscriptionCheckBox') as FormArray;
      subscriptionArray.clear(); // Clear existing controls if necessary

      const controls = [
          new FormControl({ value: true, disabled: true }, Validators.required),
          new FormControl({ value: this.subscriptionString[1] == '2', disabled: false }, Validators.required),
          new FormControl({ value: this.subscriptionString[2] == '3', disabled: false }, Validators.required),
          new FormControl({ value: this.subscriptionString[3] == '4', disabled: false }, Validators.required),
          new FormControl({ value: this.subscriptionString[4] == '5', disabled: false }, Validators.required)
        ];

        controls.forEach(control => subscriptionArray.push(control));
    }).catch(err=>{
      this.service.showError('Something went wrong fetching client subscription ');
      console.log(err)
    })
  }
onSoftwareCheckboxChange(event: Event, software: string, fromMaster = false): void {
  try {
    const softwareCheckboxes = this.uForm.get('softwareCheckboxes') as FormGroup;

    if (softwareCheckboxes?.get('monitoring')) {
      softwareCheckboxes.get('monitoring')!.setValue(true);
      softwareCheckboxes.get('monitoring')!.disable({ emitEvent: false });
    } else {
      console.warn('softwareCheckboxes.monitoring not found');
      return;
    }

    const isChecked = fromMaster ? true : (event.target as HTMLInputElement).checked;

    switch (software) {
      case 'eMDiA1':
        softwareCheckboxes.get('diagnostics')?.setValue(isChecked);
        break;
      case 'advanced':
        ['diagnostics', 'kurtosis', 'cepstrum', 'waterfallChart', 'predictiveTab', 'powertrain'].forEach(key => {
          softwareCheckboxes.get(key)?.setValue(isChecked);
        });
        break;
    }
  } catch (error) {
    console.error('Error in onSoftwareCheckboxChange:', error);
  }
}
onSoftwareCheckboxV2(event: any) {
  const isChecked = event.checked;
  const id=event.id;
  const index = this.selectedIds.indexOf(id);
  if (isChecked) {
    if (index === -1) {
      // Add ID if not already in the list
      this.selectedIds.push(id);
    }
  } else {
    if (index !== -1) {
      // Remove ID if it exists
      this.selectedIds.splice(index, 1);
    }
  }
}

  onMasterProductChange(event: Event, productType: number): void {
    try {
      const checkbox = event.target as HTMLInputElement;
    let type=productType==1?'eMMoNA':productType==2?'eMDiA1':'advanced';
    if (checkbox.checked) {
      if (!this.client_master_products.includes(productType)) {
        this.client_master_products.push(productType);
      }
    } else {
      const index = this.client_master_products.indexOf(productType);
      if (index > -1) {
        this.client_master_products.splice(index, 1);
      }
    }
    this.onSoftwareCheckboxChange(event,type,checkbox.checked);
    } catch (error) {
      console.log(error)
    }
  }

  onDiagnosticsCheckboxChange(event: Event): void {
      const checked = (event.target as HTMLInputElement).checked;
      if(checked){
        this.uForm.get('tabsGroup.rotatingAsset.diagnostics')?.patchValue({
          selected: true,
          diagnostics_summary:{
            selected:true,
            periodic_sa: true,
          },
          velocitySpectra: true,
          accelerationSpectra: true,
          ultrasonicSpectra: true,
          magneticFieldSpectra: true,
          bearingAnalysis: true
        });
      }else{
        this.uForm.get('tabsGroup.rotatingAsset.diagnostics')?.patchValue({
          selected: false,
          diagnostics_summary:{
            selected:false,
            periodic_sa: false,
          },
          velocitySpectra: false,
          accelerationSpectra: false,
          ultrasonicSpectra: false,
          magneticFieldSpectra: false,
          bearingAnalysis: false
        });
      }
  }

  onDiagnosticsSummaryChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if(checked){
      this.uForm.get('tabsGroup.rotatingAsset.diagnostics.diagnostics_summary')?.patchValue({
        selected: true,
        periodic_sa: true,
      });
    }else{
      this.uForm.get('tabsGroup.rotatingAsset.diagnostics.diagnostics_summary')?.patchValue({
        selected: false,
        periodic_sa: false,
      });
    }
  }

  onTabChange(event: any) {
      this.tabActive = event.nextId; // Update the active tab ID
      if(this.tabActive=='tab3'){
        const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
        parentArray.controls.forEach((group: AbstractControl) => {
          const parentGroup = group as FormGroup;
          parentGroup.get('checked')?.disable();
          const children = parentGroup.get('children') as FormArray;
          children.controls.forEach((child: AbstractControl) => {
            const childGroup = child as FormGroup;
            childGroup.get('checked')?.disable();
          });
        });

      }
      if(this.tabActive=='tab2'){
        const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
        parentArray.controls.forEach((group: AbstractControl) => {
          const parentGroup = group as FormGroup;
          parentGroup.get('checked')?.enable();
          const children = parentGroup.get('children') as FormArray;
          children.controls.forEach((child: AbstractControl) => {
            const childGroup = child as FormGroup;
            childGroup.get('checked')?.enable();
          });
        });
      // DISABLE MONITORING
      const monitoringGroup = parentArray.at(0) as FormGroup;
      monitoringGroup.get('checked')?.disable();
      monitoringGroup.get('checked')?.setValue(true);

      const monitoringChildren = monitoringGroup.get('children') as FormArray;
      const monitoringTab = monitoringChildren.at(0) as FormGroup;

      monitoringTab.get('checked')?.disable();
      monitoringTab.get('checked')?.setValue(true);
        // Logic by Sarthak Moriya
        console.log(this.isKeyGenerated,"this.isGeneratingKey")
      if(this.showEditUsertxt!=='Create Client' && !this.isKeyGenerated){
        const monitoringGroup = parentArray.at(1) as FormGroup;
        monitoringGroup.get('checked')?.disable();
        monitoringGroup.get('checked')?.setValue(false);

        const monitoringChildren = monitoringGroup.get('children') as FormArray;
        const monitoringTab = monitoringChildren.at(0) as FormGroup;

        monitoringTab.get('checked')?.disable();
        monitoringTab.get('checked')?.setValue(false);
          const monitoringGroup2 = parentArray.at(2) as FormGroup;
        monitoringGroup2.get('checked')?.disable();
        monitoringGroup2.get('checked')?.setValue(false);

        const monitoringChildren2 = monitoringGroup2.get('children') as FormArray;
        const monitoringTab2 = monitoringChildren2.at(0) as FormGroup;
        const monitoringTab3 = monitoringChildren2.at(1) as FormGroup;
        const monitoringTab4 = monitoringChildren2.at(2) as FormGroup;
        const monitoringTab5 = monitoringChildren2.at(3) as FormGroup;
        const monitoringTab6 = monitoringChildren2.at(4) as FormGroup;

        monitoringTab2.get('checked')?.disable();
        monitoringTab2.get('checked')?.setValue(false);
        monitoringTab3.get('checked')?.disable();
        monitoringTab3.get('checked')?.setValue(false);
        monitoringTab4.get('checked')?.disable();
        monitoringTab4.get('checked')?.setValue(false);
        monitoringTab5.get('checked')?.disable();
        monitoringTab5.get('checked')?.setValue(false);
        monitoringTab6.get('checked')?.disable();
        monitoringTab6.get('checked')?.setValue(false);
      }
    }
  }

  onCepstrumChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if(checked){
      this.uForm.get('tabsGroup.rotatingAsset.diagnostics.bearingAnalysis')?.setValue(true);
    }else{
      this.uForm.get('tabsGroup.rotatingAsset.diagnostics.bearingAnalysis')?.setValue(false);
    }
    this.uForm.get('tabsGroup.rotatingAsset.diagnostics.bearingAnalysis')?.disable();
  }
  onPredictiveChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if(checked){
      this.uForm.get('tabsGroup.rotatingAsset.predictive')?.setValue(true);
    }else{
      this.uForm.get('tabsGroup.rotatingAsset.predictive')?.setValue(false);
    }
    this.uForm.get('tabsGroup.rotatingAsset.predictive')?.disable();
  }

  onAdvancedCheckboxChange(event: Event,key:string): void {
    if(key=='cepstrum'){
      this.onCepstrumChange(event);
    }
    if(key=='predictiveTab'){
      this.onPredictiveChange(event);
    }
  }

  atLeastOneInMasterProductsCheckedValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const isAnyChecked = (formArray as FormArray).controls.some(ctrl => ctrl.value === true);
    return isAnyChecked ? null : { atLeastOneRequired: true };
  };
}

  async fetchAlertSubscriptionTypes(client_id=null){
      if(!client_id){
          await this.service.getDataV2(this.middlewareBaseUrl + 'get-alert-subscriptions').then((response: any) => {
            // this.service.getDataV2('http://localhost:3004/get-alert-subscriptions').then((response: any) => {
              if (response && response.data && response.data.body) {
                const subscriptionTypes = response.data.body;
                this.alertSubscriptionNames=subscriptionTypes.map((item: any) => item.name);
                const alertSubscriptionArray = this.uForm.get('alert_subscription') as FormArray;
                alertSubscriptionArray.clear(); // Clear existing controls if necessary

                subscriptionTypes.forEach((type: any) => {
              const control = new FormControl({ value: false, disabled: false }, Validators.required);
              alertSubscriptionArray.push(control);
            });
          }
        }).catch((error: any) => {
          console.error('Error fetching alert subscription types:', error);
          this.service.showError('Failed to fetch alert subscription types.');
        });
      }else{
        await this.service
          .getDataV2(
            this.middlewareBaseUrl +
              "get-alert-subscriptions?client_id=" +
              client_id
          )
          .then((response: any) => {
            // this.service.getDataV2('http://localhost:3004/get-alert-subscriptions?client_id='+client_id).then((response: any) => {
            if (response && response.data && response.data.body) {
              const subscriptionTypes = response.data.body;
              const alertSubscriptionArray = this.uForm.get(
                "alert_subscription"
              ) as FormArray;
              alertSubscriptionArray.clear(); // Clear existing controls if necessary
              subscriptionTypes.forEach((item: any) => {
                const control = new FormControl(
                  { value: item?.checked ? true : false, disabled: false },
                  Validators.required
                );
                alertSubscriptionArray.push(control);
              });
            }
          })
          .catch((error: any) => {
            console.error("Error fetching alert subscription types:", error);
            this.service.showError("Failed to fetch alert subscription types.");
          });

          await this.service.getDataV2(this.middlewareBaseUrl + 'get-alert-subscriptions').then((response: any) => {
            // this.service.getDataV2('http://localhost:3004/get-alert-subscriptions').then((response: any) => {
              if (response && response.data && response.data.body) {
                const subscriptionTypes = response.data.body;
                this.alertSubscriptionNames=subscriptionTypes.map((item: any) => item.name);
          }
        }).catch((error: any) => {
          console.error('Error fetching alert subscription types:', error);
          this.service.showError('Failed to fetch alert subscription types.');
        });


      }

  }
  async loadReportSubscriptionRoles(): Promise<void> {
    try {
      if(!this._adminClientId){
        const response: any = await this.service.getDataV2(this.reportSubscriptionUrl);
        console.log(response);

        const { status, code, body } = response?.data || {};

        if (status === 'success' && code === 200 && Array.isArray(body)) {
          this.reportSubscriptionRoles = body.filter(item => !!item.role);

          const reportSubscriptionArray = this.uForm.get('reportSubscription') as FormArray;
          reportSubscriptionArray.clear(); // Clear existing controls if necessary

          this.reportSubscriptionRoles.forEach((type: any) => {
            console.log(type);
                const control = new FormControl({ value: type.id==1?true:false, disabled: type.id==1?true:false }, Validators.required);
                reportSubscriptionArray.push(control);
              });
          console.log(this.reportSubscriptionRoles);
          console.log(reportSubscriptionArray);
          console.log(this.uForm.get('reportSubscription'));
        }
      }
      else{
        // EDIT PAGE
        const response: any = await this.service.getDataV2(this.reportSubscriptionCheckUrl + `/${this._adminClientId}`);
        console.log(response);
        let {body}=response.data
        let data=body[0];
        const {summary_send_to_client,summary_send_to_user}=data
        console.log("CLIENT/USER::"+summary_send_to_client,summary_send_to_user);
        const reportSubscriptionArray = this.uForm.get('reportSubscription') as FormArray;
        reportSubscriptionArray.clear(); // Clear existing controls if necessary

        // This array shows name if hard coded return this in api response
        this.reportSubscriptionRoles=[{id:1,role:"CLIENT ADMIN"},{id:2,role:"CLIENT USER"}]
        //SEND TO CLIENT_ADMIN CHECKBOX
        let control = new FormControl({ value: summary_send_to_client==1?true:false, disabled: summary_send_to_client==1?true:false }, Validators.required);
        reportSubscriptionArray.push(control);

        //SEND TO USER USER CHECKBOX
        control = new FormControl({ value: summary_send_to_user==1?true:false, disabled:false }, Validators.required);
        reportSubscriptionArray.push(control);

        console.log(reportSubscriptionArray);

      }
    } catch (error) {
      console.error('Failed to load report subscription roles:', error);
    }
  }

  // async generateSubscriptionKey () {
  //   this.isGeneratingKey = true;
  //   try {
  //     let clientId = this._adminClientId;
  //     if (!clientId) {
  //       clientId =  null;
  //     }
  //     const response: any = await this.service.postData(`${this.generateSubscriptionKeyURL}`, { client_id: clientId });
  //     console.log(response);
  //     if(response.status === "error") {
  //       console.error('Error generating subscription key:', response.message);
  //       return;
  //     }
  //     else if(response.status === "success" && response.token) {
  //       this.isKeyGenerated = true;
  //       this.subscriptionKey = response.token;
  //       console.log('Generating subscription key for client ID:', clientId, this.isKeyGenerated);
  //       if(this.isKeyGenerated) {
  //         const formArray = this.buildFormArrayFromTree(this.software_types_v2);
  //         this.uForm.setControl('softwareCheckboxesV2', formArray);
  //         const parentArray = this.uForm.get('softwareCheckboxesV2') as FormArray;
  //         const monitoringGroup = parentArray.at(0) as FormGroup;
  //         monitoringGroup.get('checked')?.disable();
  //         monitoringGroup.get('checked')?.setValue(true);
  //         const monitoringChildren = monitoringGroup.get('children') as FormArray;
  //         const monitoringTab = monitoringChildren.at(0) as FormGroup;
  //         monitoringTab.get('checked')?.disable();
  //         monitoringTab.get('checked')?.setValue(true);
  //       }
  //     }
  //   }
  //   catch (error) {
  //     console.error('Error generating subscription key:', error);
  //   }
  //   finally {
  //     this.isGeneratingKey = false;
  //   }
  // }

  async getClientSubscription () {
    try {
      const user_id = this._adminClientId;
      const role = localStorage.getItem('role');
      if (!user_id || !role) {
        console.log('User ID or role is not set. Cannot fetch client subscription.');
        return;
      }
      const response: any = await this.service.postData(`${this.clientSubscriptionURL}`, { clientId: user_id });
      if(response.status === "success" && response.active === 0) {
        this.isKeyGenerated = false;
        this.subscriptionKey = '';
        this.subscriptionStatus = response.subscription_flag;
        console.log('Client subscription is inactive or not found.');
        this.getAdminClientUserData()
      }
      else if(response.status === "success" && response.active === 1 && response.subscription_token !== null ) {
        this.isKeyGenerated = true;
        this.subscriptionKey = response.subscription_token;
        this.subscriptionStatus = response.subscription_flag;
        console.log('Client subscription is active:', this.isKeyGenerated, this.subscriptionKey);
        this.getAdminClientUserData()
      }
      console.log(response);
    }
    catch (error) {
      console.error('Error fetching client subscription:', error);
    }finally{

    }

  }

  copyToClipboard() {
  if (!this.subscriptionKey) return;

  navigator.clipboard.writeText(this.subscriptionKey).then(() => {
    this.copied = true;
    setTimeout(() => this.copied = false, 2000); // Hide after 2s
  }).catch(err => {
    console.error('Could not copy text: ', err);
    alert('Failed to copy token.');
  });
}

disableUncheckedNonMonitoring(formArray: FormArray) {
  // const monitoringGroup = parentArray.at(0) as FormGroup;
  //     monitoringGroup.get('checked')?.disable();
  //     monitoringGroup.get('checked')?.setValue(true);
  //     const monitoringChildren = monitoringGroup.get('children') as FormArray;
  //     const monitoringTab = monitoringChildren.at(0) as FormGroup;
  //     monitoringTab.get('checked')?.disable();
  //     monitoringTab.get('checked')?.setValue(true);
  console.log("Disabling unchecked non-monitoring items");
  console.log(formArray);
  console.log(this.selectedIds);
    if(!this.isKeyGenerated) {
      const diagnosticsGroup = formArray.at(1) as FormGroup;
      console.log(diagnosticsGroup, "diagnosticsGroup")
      diagnosticsGroup.get('checked')?.disable();
      diagnosticsGroup.get('checked')?.setValue(false);
      const diagnosticsChildren = diagnosticsGroup.get('children') as FormArray;
      const diagnosticsTab = diagnosticsChildren.at(0) as FormGroup;
      console.log(diagnosticsTab, "diagnosticsTab")
      diagnosticsTab.get('checked')?.disable();
      diagnosticsTab.get('checked')?.setValue(false);
    }
}
}
